import React, { useEffect, useState } from "react";
import ReactLoading from "react-loading";
import Cookies from "universal-cookie";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { QRCode } from "react-qr-svg";
import { useTranslation } from "react-i18next";
import Countdown from "react-countdown";
import actions, { useActions } from "../redux/actions";
import { getMultiLangProperty } from "../helpers/generalHelper";

export default function QRCodeModal({ showQrCode, setShowQrCode }) {
  const UserActions = useActions(actions.UserActions);
  const cookies = new Cookies();
  const token = cookies.get("token", { path: "/" });
  const { t, i18n } = useTranslation();
  const storeConfig = useSelector((state) => state.storeConfig);
  const [content, setContent] = useState({});
  const { qrCodeToken, _id } = useSelector((state) => state.user);

  useEffect(() => {
    if (showQrCode) {
      UserActions.getQrCodeToken(token);
    }
  }, [showQrCode]);

  useEffect(() => {
    setContent(storeConfig);
  }, [storeConfig]);

  return (
    <Modal
      backdropClassName="qrCodeBackDrop"
      show={showQrCode}
      onHide={() => {
        UserActions.clearQrCode();
        setShowQrCode(false);
      }}
      dialogClassName="qrCodeDialog"
    >
      <div className="qrCodeContainer">
        <p>{getMultiLangProperty(content.siteTitle, i18n.language)}</p>
        {!qrCodeToken && showQrCode && (
          <ReactLoading type="spokes" color="#1A5CAA" />
        )}
        {qrCodeToken && (
          <QRCode
            bgColor="#FFFFFF"
            fgColor="#000000"
            level="L"
            style={{ width: 256, height: 256 }}
            value={JSON.stringify({
              token: qrCodeToken,
              user: _id,
            })}
          />
        )}
        <Countdown
          date={Date.now() + 900000}
          onComplete={() => {
            UserActions.clearQrCode();
            setShowQrCode(false);
          }}
          renderer={(props) => (
            <span className="timer">
              {props.formatted.minutes}:
{props.formatted.seconds}
            </span>
          )}
        />

        <button
          type="button"
          onClick={() => {
            UserActions.clearQrCode();
            setShowQrCode(false);
          }}
        >
          {t("quit")}
        </button>
      </div>
    </Modal>
  );
}
